import { createGuid } from '@bimser/core';
import {
	Id,
	toast,
	ToastContainer,
	ToastContainerProps,
	ToastOptions,
	UpdateOptions
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { findMessage } from '../BCIntl';
import Styles from './assets/styles.scss';
import { Notification } from './components/Notification';
import { BCNotificationProps } from './entities/BCNotificationProps';

Styles;

declare global {
	interface Window {
		globalToast: typeof toast;
	}
}

if (!window.globalToast) {
	window.globalToast = toast;
}

const BCNotification = {
	success: (args: ToastOptions & BCNotificationProps) => {
		notifyMobile(args);
		return window.globalToast.success(
			<Notification
				message={args.message}
				description={args.description}
			/>,
			args
		);
	},
	warning: (args: ToastOptions & BCNotificationProps) => {
		notifyMobile(args);
		return window.globalToast.warning(
			<Notification
				message={args.message}
				description={args.description}
				btn={args.btn}
			/>,
			args
		);
	},
	error: (args: ToastOptions & BCNotificationProps) => {
		notifyMobile(args);
		return window.globalToast.error(
			<Notification
				message={args.message}
				description={args.description}
			/>,
			args
		);
	},
	info: (args: ToastOptions & BCNotificationProps) => {
		notifyMobile(args);
		return window.globalToast.info(
			<Notification
				message={args.message}
				description={args.description}
			/>,
			args
		);
	},
	open: (args: ToastOptions & BCNotificationProps) => {
		notifyMobile(args);
		return window.globalToast(
			<Notification
				message={args.message}
				description={args.description}
			/>,
			args
		);
	},
	update: (id: Id, args: UpdateOptions) => {
		window.globalToast.update(id, args);
	},
	isActive: (id: Id) => {
		return window.globalToast.isActive(id);
	},
	destroy: (id: Id) => {
		window.globalToast.dismiss(id);
	},
	/**
	 * @deprecated This function is no longer in use. Please use warning instead.
	 */
	severeWarning: (args: ToastOptions & BCNotificationProps) => BCNotification.warning(args),
	/**
	 * @deprecated This function is no longer in use. Please use error instead.
	 */
	blocked: (args: ToastOptions & BCNotificationProps) => BCNotification.error(args),
	/**
	 * @deprecated This function is no longer in use. Please use warning instead.
	 */
	warn: (args: ToastOptions & BCNotificationProps) => BCNotification.warning(args)
};

const notifyMobile = (args: ToastOptions & BCNotificationProps) => {
	const payload = JSON.stringify({
		toasters: [],
		popups: [],
		summaries: [
			{
				typeName: 'ShowMessageAction',
				dialogType: 'Summary',
				alertType: 'Info',
				id: createGuid(),
				highlightList: args.highlightList,
				messages: args.description,
				name: args.message,
				enabled: true
			}
		],
		toggleLoading: args.description == findMessage.get('102683')
	});

	(window as any).SynergyAndroid?.mobileClientSideMessages(payload);
	(window as any).webkit?.messageHandlers?.mobileClientSideMessages?.postMessage(payload);
};

export default (props: ToastContainerProps) => {
	return <ToastContainer {...props} />;
};

export { BCNotification, Notification as NotificationComponent };
